__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-06-1775477157-stable-dev/";